import * as yup from 'yup';
import 'yup-phone';

export type ItemInputs = {
  product_id: number | null;
  storage_id: object;
  quantity: string;
  price: number;
};

export const itemSchema = yup.object().shape({
  product_id: yup.mixed().required().label('product'),
  storage_id: yup.mixed().required().label('storage'),
  quantity: yup.number().typeError('field must be a number.').required().label('quantity'),
  price: yup.number().typeError('field must be a number.').required().label('price')
});

export type InformationInputs = {
  date: object;
  stock_opname_products: ItemInputs[];
};
